<template>
  <div class="wrapper">
    <div class="animated fadeIn ">
      <b-row>
        <b-col cols="12">
         <b-breadcrumb :items="breadcrumbs"/>         
            <b-card>
            <div style="float: right;">
              <p > <b>Total Records :<span style="color:red; float: right;">{{ totalRows }}</span>&nbsp;</b> </p>

            </div>
                <b-table
                striped
                bordered
                hover
                responsive
                :items="items"
                :fields="fields"
                >
                  <template slot="rider_name" slot-scope="row">
                    {{
                      row.item &&
                      row.item.deliveryagentfirstname &&
                      row.item.deliveryagentlastname
                        ? row.item.deliveryagentfirstname + ' ' + row.item.deliveryagentlastname
                        : 'NA'
                    }}
                  </template>
                </b-table>
          
            </b-card>
   
        </b-col>
          <b-col md="12" class="my-1 d-flex justify-content-center" >

          <paginate
          v-if="totalRows > 0"
          :page-count="noofpages"
          :page-range="10"
          :margin-pages="2"
          :click-handler="clickCallback"
          :prev-text="'Prev'"
          :next-text="'Next'"
          :container-class="'pagination'"
          :page-class="'page-item'">
        </paginate>
        </b-col>
      </b-row>
  </div>
</div>
</template>
<script>
import CONSTANTS from "@/utils/constants";
import Utils from "@/utils";
import auth from "@/utils/auth";

export default {
  data: function () {
    return {
      name: 'dashboard',
       breadcrumbs: [{
        text: 'Details',
        active: true
      }],

    fields: [
      { key: 'shippingid', label: 'AWB Number' },
      { key: 'orderid', label: 'Order ID' },
      { key: 'shipmentstatus', label: 'Shipment Current Status' },
      { key: 'order_date', label: 'Order Date',
         formatter: (value) => value ? new Date(value).toLocaleString() : 'NA'
       },
      { key: 'clientshippingdate', label: 'Shipping Date' },
      { key: 'lastmodifieddate', label: 'Last Modified Date',
         formatter: (value) => value ? new Date(value).toLocaleString() : 'NA'
       },
      { key: 'shipaddress1', label: 'Customer City / Area' },
      { key: 'rider_name', label: 'Rider Name' },
      { key: 'pickuplocationmasterid', label: 'Store ID' },
      { key: 'pickuplocationname', label: 'Store Name' }
    ],

    id:'',
    pageNum:1,
    currentPage: 1,
    perPage:  20,
    items:[],
    totalRows:0,
    noofpages:'',

    }
  },
  components: {
   
    userInfo: []
  },
  created: function () {
    // this.id = this.$route.params.id;
    this.id = this.$route.query.keyword;
    console.log(this.id)
    this.getdetailsforshipemtstatus(this.id, this.pageNum);
  },
  methods: {
    getdetailsforshipemtstatus(id, pageNo){
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
      const obj ={
        keyword: id,
        hub_id: `${userInfo.pickuplocationmasterid}`,
        page_no :`${pageNo}`,
        is_superadmin: `${userInfo.is_superadmin}`,
      }
    console.log("ok",obj)
    this.$http
    .post(
      `${CONSTANTS.MISREPORT_API_URL}/getdetailsforshipemtstatus`,obj)
        .then(result => {
          // console.log(result.body);
            this.isBusy = !this.isBusy;
            if(result.body.returnmsg =="Successful"){
                
              this.items =result.body.returnvalue;
              this.totalRows = result.body.returnvalue[0].totalcount;
              this.noofpages=parseInt(this.totalRows)/20;
              this.noofpages=Math.ceil( this.noofpages);
            }else {
              this.items  = [];
              this.totalRows = 0
            }
        }).catch(ex => {
          console.log('error', ex)
        })

    },

    clickCallback (pageNum){
      this.getdetailsforshipemtstatus(this.id, pageNum);
    },
  }
};
</script>

<style>
.bg-aqua{
      background-color: #00c0ef !important;
      color: #fff!important;
}
.bg-green{
      background-color: #00a65a !important;
       color: #fff!important;
}
.bg-yellow{
      background-color: #f39c12 !important;
       color: #fff!important;
}
.bg-pink{
  background-color: #FF69B4 !important;
   color: #fff!important;
}
.bg-purpal{  
    background-color: #9370DB !important;
     color: #fff!important;
}
.bg-cyan{
      background-color: #008B8B !important;
       color: #fff!important;  
}
.bg-red{
      background-color: #dd4b39 !important;
       color: #fff!important;
}
.bg-def{
  background-color: #f09642 !important;
   color: #fff!important;
  
}
.boxto .card-body{
  padding: 0px!important;
}
.countcolor
{
      color:white !important;

}
.display-3 
{
      font-size: 3.5rem !important;
}

</style>